import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    name: "",
}

export const modelsFilterSlice = createSlice({
    name: 'modelsFilter',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = modelsFilterSlice.actions

export default modelsFilterSlice.reducer